module.exports = __webpack_public_path__ + "static/img/cstSer_bg_12.673b26d0.svg";